import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

const FeeCard = ({ title, value, subtitle, icon: Icon, gradient }) => {
  return (
    <Card sx={{ background: gradient, color: 'white', height: '100%' }}>
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>{title}</Typography>
            <Typography variant="h5" fontWeight="bold">{value}</Typography>
            {subtitle && <Typography variant="caption">{subtitle}</Typography>}
          </Box>
          {Icon && <Icon sx={{ fontSize: 40, opacity: 0.8 }} />}
        </Box>
      </CardContent>
    </Card>
  );
};

export default FeeCard;
